import React, {Dispatch, Fragment, SetStateAction} from 'react';

import {PopoverBody} from 'reactstrap';

import {StyledPopoverBottomDIV} from 'app/general/bootstrap/utils';
import {OverlayProps, PopoverForm, PopoverHeading} from 'app/general/overlays';
import {SelectDateRangeForm} from 'app/general/widgets/SelectDateRangeForm';
import {gt} from 'app/utils/i18n';

import type {
  DateRangeType,
  VALID_RANGE_TEMPLATE,
} from 'app/general/dates/date-range';

const availableDateRanges: Array<VALID_RANGE_TEMPLATE> = [
  'all-time',
  'today',
  'yesterday',
  'last-30-days',
  'this-month',
  'last-month',
  'custom',
];

export const DateRangePopover = ({
  title,
  overlayProps,
  setDateRange,
  setStatus,
  triggerCloseOnDownload,
}: {
  title: string;
  triggerCloseOnDownload?: boolean;
  overlayProps: OverlayProps;
  setStatus: Dispatch<SetStateAction<'idle' | 'exporting'>>;
  setDateRange: Dispatch<SetStateAction<DateRangeType>>;
}) => (
  <PopoverForm overlayProps={{...overlayProps, placement: 'top'}}>
    {({close, refreshPosition}) => (
      <Fragment>
        <PopoverHeading>{title}</PopoverHeading>
        <PopoverBody
          style={{
            width: 250,
          }}
        >
          <SelectDateRangeForm
            onChange={setDateRange}
            onTemplateChange={refreshPosition}
            initialValue="all-time"
            templates={availableDateRanges}
          />
        </PopoverBody>
        <StyledPopoverBottomDIV>
          <button onClick={close} className="btn btn-link btn-sm">
            {gt('Close')}
          </button>
          <button
            onClick={() => {
              setStatus('exporting');
              triggerCloseOnDownload && close();
            }}
            className="ml-1 btn btn-primary btn-sm"
          >
            {gt('Export')}
          </button>
        </StyledPopoverBottomDIV>
      </Fragment>
    )}
  </PopoverForm>
);
